import React, { useState } from 'react';

interface InputProps {
  label?: string;
  name?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url' | 'date';
  disabled?: boolean;
  error?: string;
  className?: string;
  required?: boolean;
  showToggle?: boolean;
  maxLength?: number;
}

const Input: React.FC<InputProps> = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  type = 'text',
  disabled = false,
  error,
  className = '',
  required = false,
  showToggle = false,
  maxLength,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputEl = (
    <input
      type={type === 'password' && showToggle ? (showPassword ? 'text' : 'password') : type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      maxLength={maxLength}
      className={`w-full px-3 py-2 bg-shell border border-line rounded-lg text-text placeholder-muted transition-all duration-200 hover:border-chart/30 focus:outline-none focus:ring-2 focus:ring-chart/30 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed ${
        type === 'password' && showToggle ? 'pr-10' : ''
      } ${error ? 'border-red-400' : ''}`}
    />
  );

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-text">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      {type === 'password' && showToggle ? (
        <div className="relative">
          {inputEl}
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-muted hover:text-text transition-colors"
            onClick={() => setShowPassword((v) => !v)}
            tabIndex={-1}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? (
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round">
                <path d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            ) : (
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round">
                <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            )}
          </button>
        </div>
      ) : (
        inputEl
      )}
      {error && (
        <p className="text-sm text-danger">{error}</p>
      )}
    </div>
  );
};

export default Input;
